import { MONEY_FIELD } from '../type_name'
import { VSpacer } from 'vuetify/lib'
import { formattingNumber } from '../utils'
import { Space } from '../components_from_custumer'
export default {
    name: MONEY_FIELD,
    props: {
        field: {
            type: Object,
        },
        value: {
            type: Object
        }
    },
    methods: {
        // 生成 VSpacer
        setVSpacer(h) {
            if (this.vSpacer) {
                return this.vSpacer
            }
            return this.vSpacer = h(VSpacer)
        },
        setSpace(h) {
            if (this.spacer) {
                return this.spacer
            }
            return this.spacer = h(Space)
        }
    },
    render(h) {
        const { 
            label, 
            key, 
            valueRender,
            currency_type = '',
            currency_type_key = '',
            digit = 2,
            unit = 1
         } = this.field
         const r_currency_type = this.value[currency_type_key] || currency_type || ''
        let value = isNaN(this.value[key]) ? '-' : Number(this.value[key])
        if (value !== '-') {
            if (valueRender) {
                value = valueRender({field:this.field, value:this.value})
            } else {
                value = formattingNumber(value, digit, unit)
            } 
        }
        return h('div', {
            style: {
                width: '100%',
                display: 'flex'
            }
        }, [
            h('span', {
                style:{
                    'white-space':'nowrap',
                    'margin-right': '10px'
                }
            }, label),
            this.setVSpacer(h),
            r_currency_type, 
            this.setSpace(h),
            value
        ])
    }
}